module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.bdfb2a43.woff";